import Page from '../../components/Page';
import {
    Box,
    Button,
    Typography,
} from '@mui/material';
import {
    DataGrid,
} from "@mui/x-data-grid";
import React from 'react';
import { useSelector } from "react-redux";
import { useProcessorSurveys, useDeleteSurveyFiles, useDownloadSurveyFile } from '../../hooks/useSurveys';

function ProcessorSurveyView({ companyIdOverride, embedded = false }){
    /// Processor Survey Tab
    const downloadSurveyFile = useDownloadSurveyFile();
    const company = useSelector((state) => state.CompanyReducer.userCompanies[0]);
    const companyId = companyIdOverride ?? company?.id;
    const deleteSurveyFiles = useDeleteSurveyFiles();
    const { data: allSurveys = [], isFetching: isSurveyGridLoading } = useProcessorSurveys({
        companyId,
        enabled: Boolean(companyId),
        pauseRefetch: deleteSurveyFiles.isLoading,
    });
    const isLoading = deleteSurveyFiles.isLoading || isSurveyGridLoading;
    const [rowSelectionModel, setRowSelectionModel] = React.useState([]);

    function multiDelete(items){
        swal({
            title: "DELETE FILE(S)",
            text: `Delete ${items.length} file(s) forever? This cannot be undone.`,
            icon: "warning",
            buttons: true,
            dangerMode: false,
        })
        .then((willUpdate) => {
            if (willUpdate) {
                deleteSurveyFiles.mutate(rowSelectionModel);
            } else {
                swal({
                    title: `File(s) not Deleted.`
                });
        }})
    };

    const handleDownload = (x) => {
        downloadSurveyFile.mutate({ fileId: x.fileId, name: x.name });
    };

    const rows = allSurveys;
    const columns = [
        { field: 'fileNameShort', headerName: 'Project Name', width: 250, headerClassName: 'header', editable: false},
        { field: 'processorName', headerName: 'Processor', width: 225, headerClassName: 'header'},
        { field: 'download', headerName: 'Download', width: 225, headerClassName: 'header', sortable: false, renderCell: (params) => {
            return (<Button variant="contained" color="success" onClick={() => handleDownload({fileId:params.row.id, name:params.row.fileNameShort})}>
            Download</Button>
            )}
        },
        { field: 'customerCompanyName', headerName: 'Uploader', width: 225, headerClassName: 'header'},
        { field: 'updated', headerName: 'Updated', width: 175, headerClassName: 'header', renderCell: (params) => {
            let date = new Date(params.row.updated);
            return date.toLocaleString()
        }},
        { field: 'Delete', headerName: 'Delete', width: 125, headerClassName: 'header', sortable: false,
            renderCell: (cellValues) => {
                return(
                    <Button className="delBtn" variant="contained" sx={{ bgcolor: `error.light`}}
                        onClick={() => {
                            swal({
                                title: "DELETE FILE",
                                text: `Delete this file forever? This cannot be undone.`,
                                icon: "warning",
                                buttons: true,
                                dangerMode: false,
                            })
                            .then((willUpdate) => {
                                if (willUpdate) {
                                    deleteSurveyFiles.mutate([cellValues.row.id]);
                                } else {
                                    swal({
                                        title: `File not Deleted.`
                                    });
                            }})
                    }}>
                        Delete
                    </Button>
                )
            }
        },
    ];

    const body = (
        <Box sx={{ textAlign: "center" }}>
            <Typography sx={{ textAlign:'left' }}>
                    Select the plans you want to delete.
                    {rowSelectionModel.length > 0 ?
                        <Button
                            className="delBtn" variant="contained" sx={{ bgcolor: `error.light`}}
                            onClick={() => multiDelete(rowSelectionModel)}
                        >
                            Delete
                        </Button>
                        :
                        <Button
                            disabled
                            className="delBtn" variant="contained" sx={{ bgcolor: `error.light`}}
                        >
                            Delete
                        </Button>
                    }
                </Typography>
            <Box sx={{ height: '70vh', width: '100%', mt: 1 }}>
                <DataGrid
                    style={{textAlign:'left'}}
                    checkboxSelection
                onRowSelectionModelChange={(newRowSelectionModel, params) => {
                    setRowSelectionModel(newRowSelectionModel);
                }}
                rowSelectionModel={rowSelectionModel}
                disableRowSelectionOnClick
                columns={columns}
                rows={rows}
                loading={isLoading}
                pageSizeOptions={[10, 25, 50, 100]}
            />
            </Box>
        </Box>
    );

    if (embedded) return body;
    return (
        <Page title="Surveys" style={{textAlign:'center'}}>
            {body}
        </Page>
    );
};

export default ProcessorSurveyView;
